import { useQuery } from 'data-fetching-client';
import { GET_TASK_STATUS } from '../../data/queries';
import { captureException } from '../../utils/captureException';
export function useTaskStatus(options = {}) {
  return useQuery(GET_TASK_STATUS, Object.assign({}, options, {
    onError: error => {
      var _options$onError;
      captureException(error, ['useTaskStatus']);
      (_options$onError = options.onError) === null || _options$onError === void 0 || _options$onError.call(options, error);
    }
  }));
}